import Vue from 'vue'
import VueRouter from 'vue-router'
import AdminRoutes from './admin'
import ProviderRoutes from './provider'

Vue.use(VueRouter)
export default new VueRouter({
  mode: 'history',
  routes: AdminRoutes.concat(ProviderRoutes,[
    {
      path: '/',
      name: 'Auth',
      redirect: "/",
      component: () => import('@/components/frontend/pages/auth/Auth'),
      children: [
        {
          name: 'login',
          path: '/',
          component: () => import('@/components/frontend/pages/auth/Login.vue'),
          meta: {
            title: 'Login',
          }
        },
        {
          name: 'register',
          path: '/register',
          component: () => import('@/components/frontend/pages/auth/Register.vue'),
          meta: {
            title: 'Register',
          }
        },
        {
          name: 'forgot-password',
          path: '/passwort-vergessen',
          component: () => import('@/components/frontend/pages/auth/ForgotPassword.vue'),
          meta: {
            title: 'Forgot Password',
          }
        },
        {
          name: 'code-verification',
          path: '/code-verification',
          component: () => import('@/components/frontend/pages/auth/OTPVerification.vue'),
          meta: {
            title: 'Forgot Password?'
          }
        },
        {
          name: 'reset-password',
          path: '/reset-password',
          component: () => import('@/components/frontend/pages/auth/ResetPassword.vue'),
          meta: {
            title: 'Forgot Password?'
          }
        }
      ],
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/components/admin/pages/PageNotFound.vue"),
      meta: {
        title: '404 - Page not found'
      }
    },

  ])
})
